import { Children, isValidElement, Fragment as Fragment$1 } from 'react';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';

/** @tossdocs-ignore */
function Separated(_ref) {
  var children = _ref.children,
      separator = _ref["with"];
  var childrenArray = Children.toArray(children).filter(isValidElement);
  var childrenLength = childrenArray.length;
  return /*#__PURE__*/jsx(Fragment, {
    children: childrenArray.map(function (child, i) {
      return /*#__PURE__*/jsxs(Fragment$1, {
        children: [child, i + 1 !== childrenLength ? separator : null]
      }, i);
    })
  });
}

export { Separated };
